var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ChangePasswordModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2b71cee7!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChangePasswordModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/ChangePasswordModal.vue
// module id = 436
// module chunks = 1